import { Box, Flex, Image, Text, Title } from '@mantine/core';
import { useState } from 'react';

import type { CandidatePickCard } from '../../types';

import classes from './candidate-pick-profile-header.module.scss';

type CandidatePickProfileHeaderProps = Pick<
  CandidatePickCard,
  'photoUrl' | 'displayName' | 'age'
>;

const CandidatePickPhoto = ({
  photoUrl,
  displayName,
}: Pick<CandidatePickProfileHeaderProps, 'photoUrl' | 'displayName'>) => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return null;
  }

  return (
    <Box className={classes.photoStage}>
      <Box className={classes.photoFrame}>
        <Image
          fit='contain'
          src={photoUrl}
          alt={displayName}
          className={classes.photoImage}
          onError={() => setFailed(true)}
        />
      </Box>
    </Box>
  );
};

export const CandidatePickProfileHeader = ({
  photoUrl,
  displayName,
  age,
}: CandidatePickProfileHeaderProps) => (
  <Box className={classes.root}>
    {photoUrl && (
      <CandidatePickPhoto
        key={photoUrl}
        photoUrl={photoUrl}
        displayName={displayName}
      />
    )}
    <Box className={classes.meta}>
      <Title order={3} c='primary.7' mb={4}>
        {displayName}
      </Title>
      <Flex gap={4} align='center'>
        <Text size='sm' c='tertiary.7'>
          Возраст:
        </Text>
        <Text size='sm' c='tertiary.7'>
          {age}
        </Text>
      </Flex>
    </Box>
  </Box>
);
